import { version, getGUID } from '../config/config.js';
import axios from 'axios';
export const base = {
  projectVersion: version,
  logversion: '1.0.0',
  institutionid: '',
  appid: '',
  userid: '',
  liveid: '',
  roomid: '',
  guid: getGUID(),
};

/**
 * 获取时间字符串 yyyy-MM-dd hh:mm:ss.SSS
 * @returns {string}
 */
function currentTimeString() {
  const date = new Date(Date.now() + 288e5); // UTC+8
  return date.toISOString().replace(/[a-z]/ig, ' ').trimEnd();
}

function post(data) {
  axios.post('https://zbzt-web-log.magic-school.com/stream.gif',
    JSON.stringify(data),
    {
      timeout: 3000,
      headers: {
        'Content-Type': 'text/plain;charset=UTF-8',
      }
    }
  );
}
/**
 * 用户接口调用记录
 * @param {string} funcName 
 * @param {any} params 
 * @returns 
 */
export function userFunc(funcName, params) {
  try {
    const data = {
      t: currentTimeString(),
      type: 'func',
      name: funcName,
      params,
      ...base,
      sdkType: window.zbztAVSDK_init_sdk_type
    };
  
    post(data);
  } catch (error) {
  }
}

/**
 * 对用户发送事件记录
 * @param {string} eventName
 * @param {any} params
 */
export function userEvent(eventName, params) {
  try {
    const data = {
      t: currentTimeString(),
      type: 'event',
      name: eventName,
      params,
      ...base,
      sdkType: window.zbztAVSDK_init_sdk_type
    };
  
    post(data);
  } catch (error) {}
}

/**
 * 底层SDK事件记录
 */
export function sdkEvent(eventName, params) {
  try {
    const data = {
      t: currentTimeString(),
      type: 'sdkevent',
      name: eventName,
      params,
      ...base,
      sdkType: window.zbztAVSDK_init_sdk_type
    };

    post(data);
  } catch (error) {}
}

/**
 * 接收到SDK切换的信令
 */
export function sdkChange(current, target) {
  try {
    const data = {
      t: currentTimeString(),
      type: 'pomelo',
      name: 'sdkchange',
      target,
      ...base,
      current,
      target,
    };

    post(data);
  } catch (error) {}
}

export function sdkProbe(name, data) {
  try {
    const probeData = {
      t: currentTimeString(),
      type: 'probe',
      name,
      data,
      ...base,
    };

    post(probeData);
  } catch (error) {}
}
